import axios from 'axios'

export default {
  // загрузить список диалогов
  fetchChats(filters, pageNumber, perPage) {
    const query = {
      params: {
        perPage,
        pageNumber,
        filters: []
      }
    }
    if (filters && filters.length) {
      query.params.filters.push({
        param: 'userName',
        needle: filters,
        isStrict: false
      })
    }
    return axios.get('/api/messages/', query)
  },

  // загрузить сообщения в диалоге
  fetchMessages(chatId, search, perPage, pageNumber) {
    const query = {
      params: {
        perPage,
        pageNumber
      }
    }
    if (search) {
      query.params.filters = [{
        param: 'messageText',
        needle: search
      }]
    }

    return axios.get(`/api/messages/${chatId}`, query)
  },

  // загрузить количество чатов, где есть непрочитанные сообщения
  fetchUnreadChats() {
    return axios.get('/api/messages/unread/count')
  },

  // отправка сообщения
  sendMessage(text, receiversIds, files) {
    const fd = new FormData()
    fd.append('text', text)
    fd.append('receivers', receiversIds)
    for (let i = 0; i < files.length; i += 1) {
      fd.append('file', files[i], files[i].name)
    }

    return axios.post('/api/messages', fd)
  },

  // пометить сообщения как прочитанные
  makeRead(messageIds) {
    return axios.put('/api/messages', { messages: messageIds })
  },

  // пометить все сообщения в диалоге, как прочитанные
  makeChatRead(senderId) {
    return axios.put('/api/messages/dialog/read', { senderId })
  },

  // запрос в службу поддержки
  techSupportRequest(form) {
    return axios.post('/api/messages/support', form)
  },

  // подгрузка айди пользователей
  fetchIds(filters) {
    const query = {
      params: {}
    }

    query.params.filters = filters

    return axios.get('/api/users/ids', query)
  },

  sendMassMail(subject, text) {
    return axios.post('/api/admins/mass-mail', { subject, text })
  }
}
